import React from 'react';
import styled from 'styled-components';
import { select } from '../../core/themev2';
import { getColor } from '../../core/themev3';

const SimpleTag = props => {
  const {
    text = '',
    padding = '0 6px',
    margin = '0 0 0 10px',
    backgroundColor = 'primary',
    color = 'white',
    fontSize = '10px',
    fontWeight = 700
  } = props;
  return (
    <Tag
      padding={padding}
      margin={margin}
      backgroundColor={backgroundColor}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
    >
      {text}
    </Tag>
  );
};

const Tag = styled.span`
  display: inline-block;
  border-radius: 3px;
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  background-color: ${({ backgroundColor }) => getColor(backgroundColor)};
  color: ${({ color }) => select(color)};
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  line-height: 14px;
`;

export default SimpleTag;
